import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useAgentId, useModal } from "@/hook";
import { useCreateBulkTest } from "@/query/bulkTest";
import { Modal } from "@/component/modal";
import Button from "@/component/Button";
import { TextInputGroup } from "@/component/input";
import { errorToast, successToast, warningToast } from "@/component/Toast";
import { FileUploadZone, UploadModalTitle } from "@/component/modal";


export const TEST_UPLOAD_MODAL_ID = "test-upload-modal-id";

const UploadTestCaseModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();

    const [isValidated, setIsValidated] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);
    const [title, setTitle] = useState<string>();

    const { mutateAsync: upload, isPending: isUploading } = useCreateBulkTest(agentId);

    const onClickCancel = () => {
        if (isUploading) {
            return;
        }
        setFile(null);
        setIsValidated(false);
        modal.close(TEST_UPLOAD_MODAL_ID);
    };

    const onClickConfirm = () => {
        setIsValidated(true);
        if (!file) {
            warningToast(intl.formatMessage({ id: "i00073" }));
            return;
        }
        if (!title) {
            return;
        }
        const form = {
            title: title,
            file: file
        };

        upload(form)
            .then(() => {
                successToast(intl.formatMessage({ id: "i00022" }));
                setFile(null);
                modal.close(TEST_UPLOAD_MODAL_ID);
                setIsValidated(false);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "i00023" }));
            });
    };

    return (
        <Modal id={TEST_UPLOAD_MODAL_ID}
               className="w-[860px]"
               title={
                   <UploadModalTitle label={intl.formatMessage({ id: "i09049" })}
                                     sampleFileName="nlu_bulk_test_sample"
                                     sampleFileColumns={[
                                         { attribute: "query", description: intl.formatMessage({ id: "i09015" }) },
                                         { attribute: "intent_name", description: intl.formatMessage({ id: "i09016" }) },
                                         { attribute: "skill_name", description: intl.formatMessage({ id: "i09017" }) }
                                     ]}
                   />
                }
               onClose={() => {
                   setFile(null);
                   setIsValidated(false);
               }}
        >
            <div className="modal-body">
                <TextInputGroup rowGap={8}
                                placeholder={intl.formatMessage({ id: "i09039" })}
                                invalid={isValidated && !title}
                                invalidText={intl.formatMessage({ id: "i00071" })}
                                onChange={setTitle}
                />

                <FileUploadZone file={file}
                                onChangeFile={setFile}
                />

                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            disabled={isUploading}
                            onClick={onClickCancel}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            disabled={isUploading}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default UploadTestCaseModal;
